const state = {
    // 系统样式
    systemStyle: {
      // 主题风格
      theme: 'light'
    }
  }
  const mutations = {
  }
  const actions = {}
  const getters = {
    test: () => 'test1111'
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  }
  